<tree-root
  #tree
  shTabFocusDisable
  tabindex="0"
  [ngClass]="'sh-tree-viewer'"
  [class.sh-tree-view--show-roots]="!(hideRootNodes$ | async)"
  [nodes]="treeNodes$ | async"
  [options]="treeOptions"
  [focused]="isFocused$ | async"
  (event)="onEvent($event)"
  >
  <ng-template #treeNodeFullTemplate let-node let-index="index" let-templates="templates">
    <div
      [class]="node.getClass()"
      [class.tree-node]="true"
      [class.tree-node-expanded]="node.isExpanded && node.hasChildren"
      [class.tree-node-collapsed]="node.isCollapsed && node.hasChildren"
      [class.tree-node-leaf]="node.isLeaf"
      [class.tree-node-active]="node.isActive"
      [class.tree-node-focused]="node.isFocused"
      >
      @if (index === 0) {
        <tree-node-drop-slot [dropIndex]="node.index" [node]="node.parent"> </tree-node-drop-slot>
      }

      <tree-node-wrapper
        tabindex="-1"
        [node]="node"
        [index]="index"
        [templates]="templates"
        [class.sh-visually-hidden]="node.data.isRoot && hideRootNodes$ | async"
        >
      </tree-node-wrapper>

      <tree-node-children [node]="node" [templates]="templates" [class.tree-node-loading]="loading$ | async"> </tree-node-children>
      <tree-node-drop-slot [dropIndex]="node.index + 1" [node]="node.parent"> </tree-node-drop-slot>
    </div>
  </ng-template>
  <ng-template #treeNodeWrapperTemplate let-node let-index="index">
    <div class="node-wrapper" [style.padding-left]="node.getNodePadding()">
      <tree-node-expander [node]="node"></tree-node-expander>
      @if (multiple && node.data.type !== nodeTypes.LoadMore && !node.data.disabled) {
        <tree-node-checkbox
          tabindex="-1"
          [node]="node"
        ></tree-node-checkbox>
      }
      <div
        class="node-content-wrapper"
        [class.node-content-wrapper-active]="node.isActive"
        [class.node-content-wrapper-focused]="node.isFocused"
        [class.node-content-wrapper-disabled]="node.data.disabled"
        (click)="node.mouseAction('click', $event)"
        (dblclick)="node.mouseAction('dblClick', $event)"
        (contextmenu)="node.mouseAction('contextMenu', $event)"
        (keyup.enter)="node.mouseAction('click', $event)"
        (treeDrop)="node.onDrop($event)"
        [treeAllowDrop]="node.allowDrop"
        [treeDrag]="node"
        [treeDragEnabled]="node.allowDrag()"
        >
        @switch (node.data.type) {
          @case (nodeTypes.LoadMore) {
            <ng-container *ngTemplateOutlet="loadMoreNode; context: { node: node, index: index }"></ng-container>
          }
          @default {
            <ng-container *ngTemplateOutlet="regularNode; context: { node: node, index: index }"></ng-container>
          }
        }
      </div>
    </div>
  </ng-template>

  <ng-template #loadingTemplate
    ><div class="tree-node node-wrapper--loading">
    <span>{{ loadingMsg }}</span>
  </div></ng-template
  >
</tree-root>

<ng-template #regularNode let-node="node" let-index="index">
  <tree-node-content [node]="node" [index]="index"></tree-node-content>
</ng-template>
<ng-template #loadMoreNode let-node="node" let-index="index">
  @if (node.data.name !== loadingMsg) {
    <button class="sh-link">
      <tree-node-content [node]="node" [index]="index"></tree-node-content>
    </button>
  }
  @if (node.data.name === loadingMsg) {
    <span>
      <tree-node-content [node]="node" [index]="index"></tree-node-content>
    </span>
  }
</ng-template>
